// Shared mutable scene state used by R3F + GSAP ScrollTrigger
// Exposed as refs so GSAP can animate numeric values without re-renders.

export const sceneState = {
  camera: {
    posX: 0,
    posY: 2.2,
    posZ: 9.2,
    lookX: 0,
    lookY: 0.6,
    lookZ: 0,
  },
  waves: {
    bigElevation: 0.32,
    bigFrequencyX: 1.1,
    bigFrequencyZ: 0.85,
    bigSpeed: 0.35,
    smallElevation: 0.12,
    smallFrequency: 2.6,
    smallSpeed: 0.22,
  },
  particles: {
    drift: 0.04,
    opacity: 0.9,
    count: 4200,
  },
  logo: {
    posY: 1.25,
    posZ: 0,
    rotY: 0,
    scale: 1.0,
    opacity: 1.0,
  },
  fog: {
    near: 8,
    far: 55,
  },
  progress: 0,
};
